import React from 'react';
// material-ui
import { Box, CircularProgress } from '@mui/material';
// models
import { Condiments, FirstMenu, ItemUnit, MenuDish, TaxGroup } from '../../models';
// component
import MenuDishDetailMultiple from './menu-dish-detail-multiple.component';
import MenuDishDetail from './menu-dish-detail.component';

import _ from 'lodash';
import { apiManage_rbp } from '../../request';

export default class MenuDishComponent extends React.Component<Props, State> {
    public state: State = {
        // 模式 编辑菜品 批量编辑菜品
        mode: 'SINGLE',
        // 所属菜单 不同菜单的同一菜品
        dishes: [],
        // 当前菜品详情
        detail: {},
        isLoading: false
    }
    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        await this.init()
    }
    // *********************
    // Default Function
    // *********************
    /**
     * 初始化
     */
    async init() {
        const { detail } = this.props;
        if (detail.item_id || detail.item_id === 0) {
            this.setState({ isLoading: true });
            const result = await apiManage_rbp.get_dishes(Number(detail.origin_id) || detail.item_id);
            if (!_.get(result, 'error')) {
                this.setState({
                    dishes: result,
                    detail: result.find((item) => item.item_id === (Number(detail.origin_id) || detail.item_id)) || {}
                })
            }
            this.setState({ isLoading: false });
        }

    }
    // *********************
    // View
    // *********************

    render() {
        const { mode, dishes, detail, isLoading } = this.state;
        return (
            <Box marginTop='18px' position={'relative'} >
                {isLoading && <Box className='table-loading' sx={(theme) => { return { zIndex: 2, background: `${theme.palette.background.default}90` } }}>
                    <CircularProgress color='primary' />
                </Box>}
                {
                    mode === 'SINGLE' ?
                        <MenuDishDetail
                            key={detail.item_id}
                            handleChangeMode={() => {
                                this.setState({
                                    mode: 'MULTIPLE'
                                })
                            }}
                            dishes={dishes}
                            {
                            ...this.props
                            }
                            detail={{
                                ...this.props.detail,
                                ...detail
                            }}
                            printGroup={this.props.printGroup}
                            priceSpecList={this.props.priceSpecList}
                        />
                        :
                        <MenuDishDetailMultiple
                            key={detail.item_id}
                            handleChangeMode={() => {
                                this.setState({
                                    mode: 'SINGLE'
                                })
                            }}
                            dishes={dishes}
                            {
                            ...this.props
                            }
                            detail={{
                                ...this.props.detail,
                                ...detail
                            }}
                        />
                }
            </Box>
        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 菜品详情
    detail: MenuDish;
    // 返回
    handleClickBack: () => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 更新当前显示的菜品详情
    updateDetail: (detail: MenuDish) => void;
    // 税率组
    taxGroup: TaxGroup[]
    // 菜单数据（含菜品，供套餐选择菜品使用）
    menuListForSet: FirstMenu[];
    // 菜单数据
    menuData: FirstMenu[];
    // 调味品组
    condimentsGroup: Condiments[];
    // 打印组(岗位)
    printGroup: any[];
    // 菜品规格列表
    priceSpecList: ItemUnit[];
    // 报表主类别
    majorGroup: any[];
    // 报表子类别
    mergetypes: any[];
}
type State = {
    // 模式 编辑菜品 批量编辑菜品
    mode: 'SINGLE' | 'MULTIPLE';
    // 所属菜单 不同菜单的同一菜品
    dishes: MenuDish[];
    // 当前菜品详情
    detail: MenuDish;
    isLoading: boolean;
}